import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';

const { FiHome, FiArrowLeft } = FiIcons;

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - NuPitch</title>
        <meta name="description" content="The page you're looking for could not be found." />
      </Helmet>

      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="container-responsive py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-md mx-auto"
          >
            <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-8">
              <span className="text-4xl font-bold text-primary-600">404</span>
            </div>
            
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Page Not Found
            </h1>
            
            <p className="text-gray-600 mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-4">
              <Link
                to="/"
                className="inline-flex items-center space-x-2 bg-primary-600 text-white px-6 py-3 rounded-lg hover:bg-primary-700 transition-colors focus-ring"
              >
                <SafeIcon icon={FiHome} className="w-4 h-4" />
                <span>Go Home</span>
              </Link>
              
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center space-x-2 text-gray-600 hover:text-gray-800 focus-ring rounded-lg px-3 py-2"
              >
                <SafeIcon icon={FiArrowLeft} className="w-4 h-4" />
                <span>Go Back</span>
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default NotFound;